import { createStructuredSelector } from "reselect";
import {
    SALT_LIST,
    SALT_LIST_SUCCESS,
    SALT_LIST_ERROR,
    SALT_PAGE_SET,
    SALT_HEADER,
    SALT_SEARCH_SET,
    SALT_SEARCH_CHANGE,
    SALT_ADD_SET,
    SALT_ADD_MODAL_SET,
    SALT_ADD,
    SALT_ADD_SUCCESS,
    SALT_ADD_ERROR,
    SALT_ADD_CHANGE,
    SALT_EDIT_SET,
    SALT_EDIT_CHANGE,
    SALT_EDIT_MODAL_SET,
    SALT_DETAIL,
    SALT_DETAIL_SUCCESS,
    SALT_DETAIL_ERROR,
    SALT_UPDATE,
    SALT_UPDATE_SUCCESS,
    SALT_UPDATE_ERROR
} from "../actions";

export const NAME = 'salt';

export const SaltList = (page, num_page, orderBy, filters, stateFilter) => ({
    type: SALT_LIST,
    payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, filtersState: stateFilter }
});

export const SaltListSuccess = (data) => ({
    type: SALT_LIST_SUCCESS,
    payload: data
});

export const SaltListError = (error) => ({
    type: SALT_LIST_ERROR,
    payload: error
});

export const SaltPageSet = (data) => ({
    type: SALT_PAGE_SET,
    payload: data
});

export const SaltHeader = (data) => ({
    type: SALT_HEADER,
    payload: data
})

export const SaltSearchSet = (data) => ({
    type: SALT_SEARCH_SET,
    payload: data
});

export const SaltSearchChangeSet = (data) => ({
    type: SALT_SEARCH_CHANGE,
    payload: data
});


export const SaltAddChangeSet = (data) => ({
    type: SALT_ADD_CHANGE,
    payload: data
});

export const SaltAddSet = (data) => ({
    type: SALT_ADD_SET,
    payload: data
});

export const SaltAddModalSet = (data) => ({
    type: SALT_ADD_MODAL_SET,
    payload: data
});

export const SaltAdd = (data) => ({
    type: SALT_ADD,
    payload: data
});

export const SaltAddSuccess = (message) => ({
    type: SALT_ADD_SUCCESS,
    payload: message
});

export const SaltAddError = (error) => ({
    type: SALT_ADD_ERROR,
    payload: error
});

export const SaltEditSet = (data) => ({
    type: SALT_EDIT_SET,
    payload: data
});

export const SaltEditChangeSet = (data) => ({
    type: SALT_EDIT_CHANGE,
    payload: data
});

export const SaltEditModalSet = (data) => ({
    type: SALT_EDIT_MODAL_SET,
    payload: data
});

export const SaltEditTabSet = (data) => ({
    type: SALT_EDIT_TAB_SET,
    payload: data
});

export const SaltDetail = (data) => ({
    type: SALT_DETAIL,
    payload: data
});

export const SaltDetailSuccess = (data) => ({
    type: SALT_DETAIL_SUCCESS,
    payload: data
});

export const SaltDetailError = (error) => ({
    type: SALT_DETAIL_ERROR,
    payload: error
});

export const SaltUpdate = (data) => ({
    type: SALT_UPDATE,
    payload: data
});

export const SaltUpdateSuccess = (message) => ({
    type: SALT_UPDATE_SUCCESS,
    payload: message.message
});

export const SaltUpdateError = (error) => ({
    type: SALT_UPDATE_ERROR,
    payload: error
});



const salt = (state) => state[NAME];

export const SaltSelector = createStructuredSelector({
    salt
})
